import { render } from "./NFT.vue?vue&type=template&id=f2d4f248&scoped=true"
const script = {}

import "./NFT.vue?vue&type=style&index=0&id=f2d4f248&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2d4f248"]])

export default __exports__